import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const BookingProcess: React.FC = () => {
  const content = (
    <>
      <h2>Bookingprocessen forklaret</h2>
      <p>
        Forstå hele bookingprocessen fra start til slut, så du ved præcis hvad der sker hvornår.
      </p>

      <h3>Fase 1: Søgning og udforsk

ning</h3>
      <p>
        Først finder du det værktøj du har brug for:
      </p>
      <ul>
        <li>Søg efter specifikt værktøj</li>
        <li>Gennemse kategorier</li>
        <li>Sammenlign priser og anmeldelser</li>
        <li>Læs beskrivelser og se billeder</li>
      </ul>

      <h3>Fase 2: Anmodning</h3>
      <p>
        Når du har fundet det rette værktøj:
      </p>
      <ul>
        <li>Vælg dine ønskede datoer</li>
        <li>Se den beregnede pris</li>
        <li>Tilføj en besked til ejeren (valgfrit men anbefalet)</li>
        <li>Klik "Send bookinganmodning"</li>
      </ul>
      <p>
        <strong>Vigtigt:</strong> Din booking er IKKE bekræftet endnu. Ejeren skal acceptere først.
      </p>

      <h3>Fase 3: Venter på godkendelse</h3>
      <p>
        Ejeren modtager en notifikation og har 48 timer til at svare. De kan:
      </p>
      <ul>
        <li><strong>Acceptere:</strong> Din booking er bekræftet!</li>
        <li><strong>Afvise:</strong> Du skal finde et andet værktøj</li>
        <li><strong>Sende besked:</strong> For at stille spørgsmål eller foreslå ændringer</li>
      </ul>
      <p>
        Du får en email og notifikation når ejeren svarer.
      </p>

      <h3>Fase 4: Bekræftet booking</h3>
      <p>
        Når ejeren accepterer:
      </p>
      <ul>
        <li>Bookingen er nu bekræftet</li>
        <li>Værktøjet er reserveret til dig på de valgte datoer</li>
        <li>Du kan nu chatte med ejeren om detaljer</li>
        <li>Aftale præcis tidspunkt for afhentning</li>
      </ul>

      <h3>Fase 5: Koordinering</h3>
      <p>
        Brug chatfunktionen til at aftale:
      </p>
      <ul>
        <li>Nøjagtig tidspunkt for afhentning og returnering</li>
        <li>Adresse eller mødested</li>
        <li>Betalingsmetode og -tidspunkt</li>
        <li>Eventuelle specielle instruktioner</li>
        <li>Hvad der følger med værktøjet</li>
      </ul>

      <h3>Fase 6: Afhentning</h3>
      <p>
        På afhentningsdagen:
      </p>
      <ul>
        <li>Mød til den aftalte tid</li>
        <li>Tjek værktøjet nøje</li>
        <li>Tag billeder af tilstanden</li>
        <li>Få en kort introduktion til brugen</li>
        <li>Håndter betaling som aftalt</li>
        <li>Bekræft afhentning i appen</li>
      </ul>

      <h3>Fase 7: Lejeperiode</h3>
      <p>
        Under lejeperioden:
      </p>
      <ul>
        <li>Brug værktøjet som aftalt</li>
        <li>Kontakt ejeren ved problemer</li>
        <li>Opbevar værktøjet sikkert</li>
        <li>Behandl det som dit eget</li>
      </ul>

      <h3>Fase 8: Returnering</h3>
      <p>
        Ved returnering:
      </p>
      <ul>
        <li>Rengør værktøjet</li>
        <li>Returner det til tiden</li>
        <li>Medbringe alt tilbehør</li>
        <li>Bekræft returnering i appen</li>
      </ul>

      <h3>Fase 9: Anmeldelse</h3>
      <p>
        Efter bookingen er afsluttet:
      </p>
      <ul>
        <li>Du kan anmelde ejeren og værktøjet</li>
        <li>Ejeren kan anmelde dig som lejer</li>
        <li>Anmeldelser hjælper fællesskabet</li>
      </ul>

      <h3>Hvis noget går galt</h3>
      <p>
        Kontakt DoMore support hvis:
      </p>
      <ul>
        <li>Ejeren ikke svarer på din anmodning</li>
        <li>Værktøjet ikke matcher beskrivelsen</li>
        <li>Der opstår en tvist</li>
        <li>Værktøjet er beskadiget ved afhentning</li>
      </ul>
    </>
  );

  return (
    <HelpArticle
      title="Bookingprocessen forklaret"
      category="Værktøjsleje"
      content={content}
      relatedArticles={[
        { title: 'Foretag din første booking', link: '/help/first-booking' },
        { title: 'Afhentning og returnering', link: '/help/pickup-return' },
      ]}
    />
  );
};

export default BookingProcess;
